import { useStores } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { toast } from 'sonner';

import { useScrollParentSentinelLoadMore } from '@/hooks/use-scroll-parent-sentinel-load-more';

export const OlderRunsLoader = observer(
  ({ routineId }: { routineId: number }) => {
    const { reports } = useStores();
    const hasMorePages = reports.hasMoreRoutineRuns(routineId);
    // Stable, so a failed load does not rebuild the observer and retry at once
    const loadNextPage = useCallback(
      () =>
        reports.loadMoreRoutineRuns(routineId).catch(() => {
          toast.error('Could not load older runs');
        }),
      [reports, routineId]
    );
    const { sentinelRef } = useScrollParentSentinelLoadMore({
      hasMorePages,
      loadNextPage,
    });
    if (!hasMorePages) return null;

    return (
      <div ref={sentinelRef} className="h-2 w-full shrink-0" aria-hidden />
    );
  }
);
